import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faDoorOpen, faEarthAmericas, faMobile, faPhone } from "@fortawesome/pro-regular-svg-icons";

interface IBookingSourceIconProps {
  source?: string | null;
  className?: string;
}

const BOOKING_SOURCE_ICONS: Record<string, IconDefinition> = {
  online: faEarthAmericas,
  booking_engine: faEarthAmericas,
  mobile: faMobile,
  phone: faPhone,
  walk_in: faDoorOpen,
};

export default function BookingSourceIcon({ source, className = "booking-participant_icon" }: IBookingSourceIconProps) {
  if (!source) {
    return null;
  }

  const icon = BOOKING_SOURCE_ICONS[source];

  if (!icon) {
    return null;
  }

  return <FontAwesomeIcon icon={icon} className={className} />;
}
